export default "__VITE_ASSET__BgCpoUGW__"